import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTeam } from "../services/api";

export const getTeam = createAsyncThunk("team/fetchTeam", async () => {
  const response = await fetchTeam();
  return response;
});

const teamSlice = createSlice({
  name: "team",
  initialState: { data: [], status: "idle" },
  extraReducers: (builder) => {
    builder
      .addCase(getTeam.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getTeam.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getTeam.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default teamSlice.reducer;